import {  defineMessages } from 'react-intl'

const messages = defineMessages({
    billing_not_set: {
        id: 'billing.billing_not_set',
        defaultMessage: 'Billing is not set up!'
    },
    invoices: {
        id: 'billing.invoices',
        defaultMessage: 'Invoices'
    },
    upcoming_invoice: {
        id: 'billing.upcoming_invoice',
        defaultMessage: 'Upcoming Invoice'
    },
    edit_billing_details: {
        id: 'billing.edit_billing_details',
        defaultMessage: 'Edit Billing & Subscriptions'
    },
    edit_billing_details_subscriptions: {
        id: 'billing.edit_billing_details_subscriptions',
        defaultMessage: 'Billing & Subscriptions'
    },
    no_subscribtion_plan: {
        id: 'billing.no_subscribtion_plan',
        defaultMessage: 'You have no active subscription plan. You can have up to 2 free clients but if you want more you will need to choose the subscription.'
    },
    no_subscription_plan: {
        id: 'billing.no_subscription_plan',
        defaultMessage: 'You have no active subscription plan. You cannot use the app until you select a subscription plan.'
    },
    no_active_subscriptions: {
        id: 'billing.no_active_subscriptions',
        defaultMessage: 'There are no active subscriptions.'
    },
    created: {
        id: 'billing.created',
        defaultMessage: 'Created'
    },
    amount: {
        id: 'billing.amount',
        defaultMessage: 'Amount'
    },
    status: {
        id: 'billing.status',
        defaultMessage: 'Status'
    },
    link: {
        id: 'billing.link',
        defaultMessage: 'Link'
    },
    paid: {
        id: 'billing.paid',
        defaultMessage: 'Paid'
    },
    view_invoice: {
        id: 'billing.view_invoice',
        defaultMessage: 'View Invoice'
    },
    pending: {
        id: 'billing.pending',
        defaultMessage: 'Pending'
    },
    invoice_preview: {
        id: 'billing.invoice_preview',
        defaultMessage: 'This is a preview of the invoice that will be billed on'
    },
    it_may_change: {
        id: 'billing.it_may_change',
        defaultMessage: 'It may change if the subscription is updated.'
    },
    description: {
        id: 'billing.description',
        defaultMessage: 'Description'
    },
    quantity: {
        id: 'billing.quantity',
        defaultMessage: 'Quantity'
    },
    subtotal: {
        id: 'billing.subtotal',
        defaultMessage: 'Subtotal'
    },
    total: {
        id: 'billing.total',
        defaultMessage: 'Total'
    },
    amount_due: {
        id: 'billing.amount_due',
        defaultMessage: 'Amount due'
    },
    error_exists: {
        id: 'billing.error_exists',
        defaultMessage: 'Some error exists. Try again later!'
    },
    you_must_have_the_subscription_for_stripe_connect_active_remove_ability_at: {
        id: 'stripe_connect.you_must_have_the_subscription_for_stripe_connect_active_remove_ability_at',
        defaultMessage: 'You must have the subscription for stripe connect active! You currently do not have one active. This means that you will be unable to use stripe connect features after {dateFormat} and you will be unable to sell content and/or receive payments.'
    },
    subscribe_to_unlock_stripe_connect_features: {
        id: 'stripe_connect.subscribe_to_unlock_stripe_connect_features',
        defaultMessage: 'Subscribe to unlock stripe connect features'
    },
    onBoardingSuccessfull_title: {
        id: 'stripe_connect.onBoardingSuccessfull_title',
        defaultMessage: 'Stripe Connected Successfully'
    },
    onBoardingSuccessfull_description: {
        id: 'stripe_connect.onBoardingSuccessfull_description',
        defaultMessage: 'Congratulations! Your Stripe account has been successfully connected. You can now receive payments from your clients.'
    },
    go_to_your_stripe_account_dashboard_and_there_you_can_check_your_payments: {
        id: 'stripe_connect.go_to_your_stripe_account_dashboard_and_there_you_can_check_your_payments',
        defaultMessage: 'Go to your Stripe Account Dashboard and there you can check your payments.'
    },
    go_to_your_stripe_account_dashboard: {
        id: 'stripe_connect.go_to_your_stripe_account_dashboard',
        defaultMessage: 'Go to your Stripe Account Dashboard'
    },
    if_you_want_to_be_able_to_receive_payments_from_your_clients_you_need_to_connect_using_stripe_connect: {
        id: 'stripe_connect.if_you_want_to_be_able_to_receive_payments_from_your_clients_you_need_to_connect_using_stripe_connect',
        defaultMessage: 'If you want to be able to receive payments from your clients you need to connect using Stripe Connect.'
    },
    remove_stripe_connected_account: {
        id: 'stripe_connect.remove_stripe_connected_account',
        defaultMessage: 'Remove Stripe Connected Account'
    },
    are_you_sure_that_you_want_to_remove_this_stripe_connected_account: {
        id: 'stripe_connect.are_you_sure_that_you_want_to_remove_this_stripe_connected_account',
        defaultMessage: 'Are you sure you want to remove your Stripe Connected Account? This will prevent you from selling your products on the marketplace.'
    },
    please_type_confirm_in_the_text_field_to_be_able_to_remove_the_stripe_connected_account: {
        id: 'stripe_connect.please_type_confirm_in_the_text_field_to_be_able_to_remove_the_stripe_connected_account',
        defaultMessage: 'Please type the number in the text field to be able to remove the Stripe Connected Account.'
    },
    error_delete_stripe_connected_account: {
        id: 'stripe_connect.error_delete_stripe_connected_account',
        defaultMessage: '"Error deleting stripe connected account. Make sure your account has no pending transactions or is not linked to any active subscriptions"'
    },

})

export default messages;
